/* jshint esversion: 6 */

export const textInputProps = {
	props: {
		value: {
			type: String,
			default: '',
			required: false
		},
		name: {
			type: String,
			default: 'inputName',
			required: true
		},
		error: {
			type: String,
			default: '',
			required: false
		},
		placeholder: {
			type: String.default,
			default: '',
			required: false
		},
		id: {
			type: String,
			default: '',
			required: false
		},
		size: {
			type: String,
			default: '',
			required: false
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		autocomplete: {
			type: String,
			default: '',
			required: false
		},
		isPassword: {
			type: Boolean,
			default: false,
			required: false
		},
		theme: {
			type: String,
			default: 'white',
			required: false
		}
	}
};